import {
  post,
  get,
  postJson
} from '../api/axios2'

const common = {
  async decrypt(p = '', url = 'public/decrypt', type = 'get') {
    //  console.log(type);
    if (type == 'get') {
      return await get(url, p)
    } else {
      return await postJson(url, p)
    }
  },

  add0(m){return m<10?'0'+m:m },
  format(shijianchuo){
  //shijianchuo是整数，否则要parseInt转换
    var time = new Date(shijianchuo);
    var y = time.getFullYear();
    var m = time.getMonth()+1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();
  return y+'-'+ this.add0(m)+'-'+this.add0(d)+' '+this.add0(h)+':'+this.add0(mm)+':'+this.add0(s);
  },
  menuPermission(item,val) { // 判断菜单权限 
    let isAdvanced = false
    function menuPermissionDigui(item) {
      item.forEach(e=>{
        if(e.path == val) {
          isAdvanced = true
        }
        if(e.children) {
          menuPermissionDigui(e.children)
        }
      })
    }
    menuPermissionDigui(item)
    return isAdvanced
  },


}

export default common